import { motion, useAnimation } from "framer-motion";
import type { PropsWithChildren } from "react";
import React from "react";
interface AnimateWrapper {
  activeIndex: number;
  defaultIndex?: number;
  isPrev: boolean;
}
const AnimateWrapper = (props: PropsWithChildren<AnimateWrapper>) => {
  const { activeIndex, isPrev, defaultIndex, children } = props;
  const animation = useAnimation();
  // const [prevIdx, setPrevIdx] = useState();
  React.useEffect(() => {
    if (activeIndex === defaultIndex) {
      animation.set({
        opacity: 0,

        x: isPrev ? -52 : 52,
        transition: { duration: 0.6, type: "tween" },
      });
      animation.start({
        opacity: 1,

        x: 0,
        transition: { duration: 1.2, type: "tween" },
      });
    } else {
      animation.start({
        opacity: 0,

        x: !isPrev ? -52 : 52,
        transition: { duration: 0.6, type: "tween" },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animation, activeIndex, defaultIndex]);
  return <motion.div animate={animation}>{children}</motion.div>;
};

export default AnimateWrapper;
